// extracted by mini-css-extract-plugin
export default {"logo_box":"Logo_logo_box__r0QnQ","logo_text":"Logo_logo_text__b560o"};